module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA0klEQVRYR+3UvQ3CMBAF4OfCrtkERggbwAauPJSrbAAbkBHIJtR2YXQSlpAF/rkUaS5tYr1P75xT2PlRO+dDANKANCANbGrAWnugRTbP84u70NgACtdaPyg4xnjmIliAHK6UOhEgpfTkIoYBRfj6qf7IRQwByvAQwkQAY8wCgIXoBvwKz3Ond1xEF6AWnm8/F9EE9IRvQVQBI+FcRBXgnLsAuAFY6cL1/uvf4wBw9d7f/y2q5ggIEUJYesOLJqZaOH3bBHBXbO85AUgD0oA0IA28AWH3pCGYuJx6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_up.png
// module id = IJDO
// module chunks = 1